export default {"src":"/_next/static/media/modal-cross-icon-privacy-preference.e50a6e67.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};